import { find as _find } from 'lodash';
import { filter as _filter } from 'lodash';
import { uniqBy as _uniqBy } from 'lodash';
import LookupService from './lookupService';

export default class AuthService {
  constructor($http, $q, $state, appConfig, angularAuth0, enums, storageProvider = window.sessionStorage) {
    "ngInject";

    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.appConfig = appConfig;
    this.storageProvider = storageProvider;
    this.lookupService = new LookupService($http, $q, appConfig);
    this.angularAuth0 = angularAuth0;
    this.enums = enums;    
    this.lookupService.lookupRoles()
      .then(roles => {
        this.roles = roles;
    });

    this.loggingIn = false;

    this.authData = {
      siteMapCollection : []
    };

    this.retrieveLoggedInData();
  }

  retrieveLoggedInData() {
    this.authData = JSON.parse(this.storageProvider.getItem('authData')) || {siteMapCollection : []};
  }

  authorize(authCodeOrEmail, isRenew) {
    let authService = this;

    const deferred = this.$q.defer();

    let url = '';

    if (this.appConfig.useAuth0) {
      url = this.appConfig.apiServiceBaseUri + `api/auth/ExternalAuthByEmail${this.appConfig.isLeadManager ? '_LM' : ''}`
    }
    else{
      url = this.appConfig.apiServiceBaseUri + `api/auth/ExternalAuth`
    }

    this.loggingIn = true;

    this.$http.post(url, authCodeOrEmail).success(response => {
      let tempAuthData = response;

      if (!isRenew){
        if (tempAuthData.userLocations && tempAuthData.userLocations.length) {
          //Get Default Location if any
          var defaultLocation = _find(tempAuthData.userLocations, o => o.defaultLocation);
  
          tempAuthData.currentLocation = defaultLocation || tempAuthData.userLocations[0];
        }
  
        tempAuthData.msgCount = tempAuthData.msgCount || 0;

        this.storageProvider.setItem('authData', JSON.stringify(tempAuthData));
        Object.assign(this.authData, tempAuthData);

        this.getLocationExtendedProperties('dashboardPreferences');
      }
      else{
        this.authData.authToken = response.authToken;
        this.authData.expiry = response.expiry;
        this.storageProvider.removeItem('authData');
        this.storageProvider.setItem('authData', JSON.stringify(this.authData));        
      }

      deferred.resolve();
    }).error((err, status) => {
        this.logOut();
        deferred.reject(err, status);
    }).finally(() => {
      this.loggingIn = false;
    });

    return deferred.promise;
  }

  authorize_Auth0(accessToken) {
    let authService = this;

    const deferred = this.$q.defer();

    let url = this.appConfig.apiServiceBaseUri + `api/auth/ExternalAuth_Auth0${this.appConfig.isLeadManager ? '_LM' : ''}`

    this.loggingIn = true;

    this.$http.post(url, accessToken).success(response => {
      let tempAuthData = response;

      if (tempAuthData.userLocations && tempAuthData.userLocations.length) {
        //Get Default Location if any
        var defaultLocation = _find(tempAuthData.userLocations, o => o.defaultLocation);

        tempAuthData.currentLocation = defaultLocation || tempAuthData.userLocations[0];
      }

      tempAuthData.msgCount = tempAuthData.msgCount || 0;

      this.storageProvider.setItem('authData', JSON.stringify(tempAuthData));
      Object.assign(this.authData, tempAuthData);

      deferred.resolve();
    }).error((err, status) => {
        this.logOut();
        deferred.reject(err, status);
    }).finally(() => {
      this.loggingIn = false;
    });

    return deferred.promise;
  }

  login(loginData) {
    let authService = this;
    const deferred = this.$q.defer();

    this.$http.post(this.appConfig.apiServiceBaseUri + 'api/auth/login', loginData).then(response => {
        authService.updateAuthAfterAuthentication(response.data);

        deferred.resolve(response);

    }).catch((err, status) => {
        this.logOut();
        deferred.reject(err);
    });

    return deferred.promise;
  }

  getSkupenetToken(skupenetVehicle) {
    let authService = this;

    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/auth/skupenettoken/`, skupenetVehicle);
  }

  getSkupenetTokenEdit(skupenetId) {
    let authService = this;

    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/auth/skupenettoken/${this.authData.currentLocation.webPublisherUsername}/${skupenetId}`);
  }  

  logOut() {
    if (this.loggingIn){return;}
    const authService = this;
    const isAdmin = authService.authData.isAdmin;

    this.storageProvider.removeItem('authData');

    if (authService.authData.siteMapCollection) {
      authService.authData.siteMapCollection.map(item => authService.authData.siteMapCollection.pop(item));
    }

    authService.authData = {
      siteMapCollection : []
    };

    if (authService.$state.current.name === 'adminLogin' || isAdmin) {
      authService.$state.go('adminLogin');
    }
    else {
      if (this.appConfig.useAuth0){
        this.angularAuth0.logout({
          returnTo: this.appConfig.oauthCallbackUrl
        });
      }
      else{
        authService.$state.go('userLogin');
      }      
    }
  }

  validateUser(isAdmin, featureName, permissionToCheck, redirect) {
    const authService = this;

    if (authService.isLoggedIn()) {
      if (authService.authData.isAdmin !== isAdmin) {
        return false;
      }
      else if (featureName && permissionToCheck){
        return authService.checkFeatureAccess(featureName, permissionToCheck, redirect);
      }
    }
    else {
      return false;
    }

    return true;
  }

  updateAuthAfterAuthentication(authData) {
    const authService = this;

    authService.storageProvider.setItem('authData', JSON.stringify(authData));

    authService.authData = Object.assign(authService.authData, authData);
  }

  isLoggedIn() {
    const authService = this;

    if (Object.keys(authService.authData).length === 1 && authService.authData.siteMapCollection) {
      //User is not logged
      authService.logOut();
      return false;
    }
    else if (new Date(authService.authData.expiry) < new Date()) {
      //Token is expired
      authService.logOut();
      return false;
    }
    else {
      return true;
    }
  }

  timeToLogout() {
    return new Date(this.authData.expiry) - new Date();
  }

  isLoggedIn_NoRedirect() {
    const authService = this;

    if (Object.keys(authService.authData).length === 1 && authService.authData.siteMapCollection) {
      //User is not logged
      return false;
    }
    else if (new Date(authService.authData.expiry) < new Date()) {
      //Token is expired
      return false;
    }
    else {
      return true;
    }
  }

  unauthorized(msg) {
    const authService = this;

    authService.$state.go('unauthorized', {msg: msg});
  }

  checkFeatureAccess(featureName, permissionToCheck, redirect, brandId) {
    if (this.authData.isAdmin) { return true; }

    let hasAccess = false;

    //Get the list of All roles vailable to this user in this location (on a brand)
    let locationRoles;
    if (!brandId) {
      locationRoles = _filter(this.authData.userRoles, o => o.entityId === this.authData.currentLocation.key)
    }
    else {
      locationRoles = _filter(this.authData.userRoles, o => o.entityId === this.authData.currentLocation.key && (o.brandId === brandId || o.brandId === 1))
    }

    //Get a unique list of role Ids only
    const uniqueRolesInLocation = _uniqBy(locationRoles, o => o.roleId).map(userRole => userRole.roleId);

    //Get permission set by the feature name
    const featurePermissions = _filter(this.authData.permissionSet, o => o.featureName === featureName);

    //Get permissions specific to the unique roles
    const rolePermissions = _filter(featurePermissions, o => {
      return _find(uniqueRolesInLocation, roleId => o.roleId === roleId) !== undefined;
    });

    rolePermissions.map(perm => {
      hasAccess = hasAccess || ((perm.permissions & permissionToCheck) === permissionToCheck);
    });

    if (!hasAccess && redirect) {
      this.unauthorized(this.getUnauthorizedMsg(featureName, permissionToCheck));
    }

    return hasAccess;
  }

  getUnauthorizedMsg(featureName, permissionToCheck) {
    switch(permissionToCheck) {
      case 1:
        return `You do not have permission to View ${featureName} under ${this.authData.currentLocation.value} location`;
      case 2:
        return `You do not have permission to Add a ${featureName} under ${this.authData.currentLocation.value} location`;
      case 4:
        return `You do not have permission to Edit a ${featureName} under ${this.authData.currentLocation.value} location`;
      case 8:
        return `You do not have permission to Delete a ${featureName} under ${this.authData.currentLocation.value} location`;
    }
  }

  getLocationBrands(permissionToCheck) {
    //Get the list of Vehicle Permission Set for this user against the permissionToCheck
    const vehiclePermissions = _filter(this.authData.permissionSet, o => o.featureName === 'Vehicle' && ((o.permissions & permissionToCheck) == permissionToCheck));

    //Get the List of User Roles against the currently selected location
    const userEntityRoles = _filter(this.authData.userRoles, o => o.entityId === this.authData.currentLocation.key);

    //Filter user userEntityRoles and return only the ones that the user has vehiclePermissions on
    const userRoles = _filter(userEntityRoles, o => {
      return _find(vehiclePermissions, vehRole => o.roleId === vehRole.roleId) !== undefined;
    });

    //Return an array of brandIds from userRoles
    return userRoles.map(userRole => userRole.brandId);
  }

  getEntitiesForManagement(entityType) {
    const editEntityRoles = _filter(this.authData.permissionSet, o => {
      const viewEditPerm = 5;
      return o.featureName === 'Entity' && ((o.permissions & viewEditPerm) === viewEditPerm)
    });

    let adminRoles = _filter(this.authData.userRoles, o => {
      return _find(editEntityRoles, role => role.roleId === o.roleId) !== undefined;
    });

    if (entityType) {
      adminRoles = _filter(adminRoles, role => role.entityType === entityType);
    }

    return adminRoles.map(adminRole => adminRole.entityId);
  }

  updateLocation() {
    this.storageProvider.setItem('authData', JSON.stringify(this.authData));
    this.$state.reload();
  }

  updateLocationLogin(locationId) {
    let location = _find(this.authData.userLocations, o => o.key === parseInt(locationId));

    if (location) {
      this.authData.currentLocation = location;
      this.storageProvider.setItem('authData', JSON.stringify(this.authData));
    }
  }

  isReceptionist(entityId) {
    let hasOnlyReceptionistRole = false;
    if (!this.authData.userId || this.authData.isAdmin) {
      return hasOnlyReceptionistRole;
    }
    else {
      if (!entityId) {
        entityId = this.authData.currentLocation.key;
      }

      const receptionistDbRoleId = _find(this.roles, o => o.name.toLowerCase() === 'showroom host').roleId;
      const entityRoles = _filter(this.authData.userRoles, o => o.entityId === entityId);

      hasOnlyReceptionistRole = (entityRoles.length === 1 && entityRoles[0].roleId === receptionistDbRoleId);

      return hasOnlyReceptionistRole;
    }
  }

  isManager(entityId) {
    let hasOnlyManagerRole = false;
    if (!this.authData.userId) {
      return hasOnlyManagerRole;
    }
    else {
      if (this.authData.isAdmin) {
        return true;
      }
      
      if (!entityId) {
        entityId = this.authData.currentLocation.key;
      }

      if (!entityId) {
        return false;
      }

      const crmAdminDbRoleId = _find(this.roles, o => o.name.toLowerCase() === 'administrator').roleId;
      const salesManagerDbRoleId = _find(this.roles, o => o.name.toLowerCase() === 'sales manager').roleId;
      const entityRoles = _filter(this.authData.userRoles, o => o.entityId === entityId);

      hasOnlyManagerRole = (entityRoles[0].roleId === crmAdminDbRoleId || entityRoles[0].roleId === salesManagerDbRoleId);

      return hasOnlyManagerRole;
    }
  }

  isEntityOwner(entity) {
    if (!this.authData.userId) {
      return false;
    }
    else {
      return entity.ownerId === this.authData.userId
    }
  }

  getRole() {
    if (!this.authData.userId) {
      return null;
    }
    else if (this.authData.isAdmin) {
      return {roleId: null, name:'CarsNow Admin'};
    }

    const entityId = this.authData.currentLocation.key;
    const entityRoles = _filter(this.authData.userRoles, o => o.entityId === entityId);
    const role = _find(this.roles, o => o.roleId === entityRoles[0].roleId);

    return role;
  }

  loggedInUserName() {
    return this.authData.firstName + ' ' + this.authData.lastName;
  }

  updateLocationById(entityId){
    const locToUpdate = _find(this.authData.userLocations, o => o.key === entityId);
    this.authData.currentLocation = locToUpdate;
  }

  renewSession(){
    return this.authorize(this.authData.email, true);
  }

  getLocationExtendedProperties(key){
    const deferred = this.$q.defer();
    const location = this.authData.currentLocation;

    if (location && !location[key]) {
      this.$http.get(this.appConfig.apiServiceBaseUri + `api/auth/getLocationExtendedProperties/${location.key}/${key}`)
        .then(response => {          
          location[key] = response.data.data;

          this.storageProvider.removeItem('authData');          
          this.storageProvider.setItem('authData', JSON.stringify(this.authData));
          deferred.resolve();
      });
    }

    return deferred.promise;
  }

  hasEasierAd() {
    return this.authData.currentLocation.webPublisherType === this.enums.WEB_PUBLISHER_TYPE.EasierAd;
  }

  hasStockLoader() {
    return this.authData.currentLocation.webPublisherType === this.enums.WEB_PUBLISHER_TYPE.StockLoader;
  }  

  isSimi() {
    return this.authData.currentLocation.isSimi;
  } 
  
  docuSignLogin(enquiryId, action) {
    const state = {enquiryId, action};

    const url = `https://account.docusign.com/oauth/auth?response_type=code&scope=signature%20impersonation&client_id=${this.appConfig.docuSignClientId}&state=${JSON.stringify(state)}&redirect_uri=${this.appConfig.oauthCallbackUrl}`;

    window.location.href = url;
  }

  mazdaLogin(stateName, stateParams) {
    const provider = "mazda";
    const state = {provider, stateName, stateParams};

    const url = `${this.appConfig.mazda.baseUrl}/oauth/authorize?client_id=${this.appConfig.mazda.clientId}&response_type=code&state=${JSON.stringify(state)}&redirect_uri=${this.appConfig.oauthCallbackUrl}`;

    window.location.href = url;  
  }  

  mazdaLoginBackend(authCode, stateName, stateParams) {
    this.$http.get(this.appConfig.apiServiceBaseUri + `api/auth/mazdalogin/${authCode}`)
      .success(response => {             
        this.authData.mazdaToken = JSON.parse(response.data);
        this.storageProvider.removeItem('authData');          
        this.storageProvider.setItem('authData', JSON.stringify(this.authData));

        this.$state.go(stateName, stateParams);
    });
  }

  hasActiveMazdaToken() {
    if (!this.authData.mazdaToken) {
      return false;
    }

    const issued = new Date(this.authData.mazdaToken.iat * 1000);
    const expires = new Date(issued.getTime() + (this.authData.mazdaToken.expires_in * 1000));

    return expires > new Date();
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/authService.js